/**
 * Creates a rainbow distortion effect
 * @param {number} x - Normalized X coordinate (0-1)
 * @param {number} y - Normalized Y coordinate (0-1)
 * @param {number} inside - Inside factor (0-1)
 * @param {number} edge - Edge factor (0-1)
 * @returns {Object} Distortion offset {x, y}
 */
export const rainbowDistortion = (x, y, inside = 0.5, edge = 0.5) => ({
  x: (0.5 + (edge - inside * y) * Math.cos(Math.PI * (1 - x))) - x,
  y: (0.5 - (edge - inside * y) * Math.sin(Math.PI * (1 - x))) - y
});